import { Component, Input, type OnInit } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { MessagingChannelType } from '@tokeet-frontend/message'

@Component({
  selector: 'app-messaging-channel-contacts',
  templateUrl: './messaging-channel-contacts.component.html',
  styleUrls: ['./messaging-channel-contacts.component.scss'],
  host: {
    class: 'badge badge-secondary-info badge-pill',
  },
})
export class MessagingChannelContactsComponent implements OnInit {
  @Input() inquiry: Inquiry
  @Input() set channel(channel: MessagingChannelType) {
    this.contact = this.getContact(channel)
  }

  get guestEmail() {
    return this.inquiry?.guest?.primaryEmail || this.inquiry?.guestDetails?.email
  }

  contact: string = ''

  ngOnInit(): void {}

  getContact(channel: MessagingChannelType): string {
    switch (channel) {
      case MessagingChannelType.Whatsapp:
        return this.inquiry?.guest?.whatsapp_phone || ''
      case MessagingChannelType.SMS:
        return this.inquiry?.guest?.phone || ''
      default:
        return this.guestEmail || ''
    }
  }
}
